export default "__VITE_ASSET__LUkqSKZg__"